import { render, staticRenderFns } from "./FollowUpTab.vue?vue&type=template&id=632f05e3&scoped=true&"
import script from "./FollowUpTab.vue?vue&type=script&lang=js&"
export * from "./FollowUpTab.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpTab.vue?vue&type=style&index=0&id=632f05e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632f05e3",
  null
  
)

export default component.exports